import PropTypes from 'prop-types'
import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import NEWS_QUERY from 'graphql/news.query'

import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import NewsHeader from 'components/NewsHeader'
import BlocksNews from 'components/BlocksNews'
import ArticleGrid from 'components/ArticleGrid'
import Pagination from 'components/Pagination'

import s from './news.module.css'
import StateInitializer from '../../../components/StateInitializer'
import getGlobalSettings from '../../../helpers/getGlobalSettings'
import getSites from '../../../helpers/getSites'
import { createApolloClient } from '../../../lib/createApolloClient'

function News({
  globalSettings,
  sites,
  siteSlug,
  title = '',
  acfNews = {},
  firstFeaturePost = null,
  seo = {},
  categorySlug = '',
  site = '',
  posts = [],
  offsetPagination = {},
}) {
  if (!acfNews) return null

  const { categoriesMenu, blocks } = acfNews

  return (
    <StateInitializer
      globalSettings={globalSettings}
      sites={sites}
      siteSlug={siteSlug}
    >
      <Layout globalSettings={globalSettings}>
        <WordpressSEO
          url={`/${site}/news`}
          title={title}
          seo={seo}
          image={
            firstFeaturePost?.nodes?.[0]?.acfPost?.featuredImage?.sourceUrl
          }
        />
        <NewsHeader categorySlug={categorySlug} categories={categoriesMenu} />
        {blocks && <BlocksNews>{blocks}</BlocksNews>}
        {posts?.length > 0 && (
          <ArticleGrid
            className={s.morePosts}
            articleClassName={s.morePost}
            articles={posts}
          />
        )}
        {offsetPagination && (
          <Pagination pagination={offsetPagination} currentPage={1} />
        )}
      </Layout>
    </StateInitializer>
  )
}

News.propTypes = {
  globalSettings: PropTypes.object.isRequired,
  sites: PropTypes.array.isRequired,
  siteSlug: PropTypes.string.isRequired,
  seo: PropTypes.object,
  categorySlug: PropTypes.string,
}

export default News

export async function getStaticProps({ params }) {
  const { site } = params

  const apolloClient = createApolloClient()

  const [globalSettings, sites, { data, error }] = await Promise.all([
    getGlobalSettings(site),
    getSites(),
    apolloClient.query({
      query: NEWS_QUERY,
      context: { site },
    }),
  ])

  if (error) console.log(`Error loading News props - ${error}`)

  return {
    props: {
      ...params,
      ...data.pageBy,
      firstFeaturePost:
        data.firstFeaturePost.nodes && data.firstFeaturePost.nodes.length
          ? data.firstFeaturePost.nodes[0]
          : null,
      posts: data.posts.nodes,
      offsetPagination: data.posts.pageInfo.offsetPagination,
      globalSettings,
      sites,
      siteSlug: site,
    },
    revalidate: 60 * 60, // Revalidate every hour
  }
}

export async function getStaticPaths() {
  const sites = await getSitesForStaticPaths()

  const paths = sites.map((site) => ({
    params: {
      site,
    },
  }))

  return {
    paths,
    fallback: false,
  }
}
